const TRACKED_POST_MUTATION_FIELDS = Object.freeze([
    'reactions',
    'recentComments',
    'commentsCount',
]);

const TRACKED_POST_MUTATION_FIELD_SET = new Set(TRACKED_POST_MUTATION_FIELDS);

export function collectTrackedPostMutationFields(partial) {
    if (!partial || typeof partial !== 'object') {
        return [];
    }

    return TRACKED_POST_MUTATION_FIELDS.filter((field) => Object.prototype.hasOwnProperty.call(partial, field));
}

export function addTrackedPostMutationFields(previousState, postId, partial) {
    const trackedFields = collectTrackedPostMutationFields(partial);
    if (!postId || trackedFields.length === 0) {
        return previousState || {};
    }

    const key = String(postId);
    const currentState = previousState && typeof previousState === 'object' ? previousState : {};
    const existingFields = Array.isArray(currentState[key]) ? currentState[key] : [];
    const nextFields = [...new Set([...existingFields, ...trackedFields])];

    if (
        existingFields.length === nextFields.length
        && existingFields.every((field, index) => field === nextFields[index])
    ) {
        return currentState;
    }

    return {
        ...currentState,
        [key]: nextFields,
    };
}

export function removeTrackedPostMutationFields(previousState, postId) {
    if (!postId || !previousState || typeof previousState !== 'object') {
        return previousState || {};
    }

    const key = String(postId);
    if (!Object.prototype.hasOwnProperty.call(previousState, key)) {
        return previousState;
    }

    const nextState = { ...previousState };
    delete nextState[key];
    return nextState;
}

export function normalizeTrackedPostMutationState(mutationState) {
    const normalizedState = new Map();
    if (!mutationState || typeof mutationState !== 'object') {
        return normalizedState;
    }

    Object.entries(mutationState).forEach(([postId, fields]) => {
        const normalizedFields = Array.isArray(fields)
            ? fields.filter((field) => TRACKED_POST_MUTATION_FIELD_SET.has(field))
            : [];

        if (normalizedFields.length > 0) {
            normalizedState.set(String(postId), new Set(normalizedFields));
        }
    });

    return normalizedState;
}

export { TRACKED_POST_MUTATION_FIELDS };
